module.exports = __webpack_public_path__ + "img/muted_star.385fefe8.svg";